import i18next from 'i18next'
import en from './languages/en'
import pl from './languages/pl'
import ru from './languages/ru'
import ua from './languages/ua'
import { getCurrentLanguage } from 'utils/current-language'
import { SupportedLanguages } from 'utils/languages'

const initI18n = () =>
  i18next.init({
    lng: getCurrentLanguage(),
    fallbackLng: SupportedLanguages.pl,
    debug: false,
    returnObjects: false,
    interpolation: {
      escapeValue: true,
    },
    resources: {
      en: {
        translation: en,
      },
      pl: {
        translation: pl,
      },
      ru: {
        translation: ru,
      },
      ua: {
        translation: ua,
      },
    },
    nsSeparator: '::',
  })

const i18n = (key, props?): string => i18next.t(key, { ...props, returnDetails: false }) as any

const getTranslationsMap = (): any => i18next.getResourceBundle(getCurrentLanguage(), '')

export { initI18n, i18n, getTranslationsMap }
